import React from 'react'
import { object, func, oneOfType, array } from 'prop-types'
import { translate } from 'react-i18next'

import { PagesPaths } from '../../constants/Pages'
import { InquiryDetailsHeader } from './InquiryDetailsHeader'
import { SubHero } from '../header/SubHero'

export const InquiryDetails = translate()(({ inquiry, t, children, account, onCloseSearch }) => {
  const breadcrumbs = [
    { name: t('common:visits:my_requests'), path: PagesPaths.INQUIRIES.path },
    { name: `${t('common:visits:request_of')} ${inquiry.date}` }
  ]
  return (
    <div>
      <SubHero breadcrumb={breadcrumbs} />
      <div className='layout__container demandes'>
        <h1 className='main-title demandes__title'>{t('common:visits:current_inquiry', { date: inquiry.date })}</h1>
        <div className='demandes__box'>
          <InquiryDetailsHeader
            inquiry={inquiry}
            gardenSurface={account ? account.gardenSurface : 0}
            onCloseSearch={onCloseSearch}
            />
          { children }
        </div>
      </div>
    </div>
  )
})

InquiryDetails.propTypes = {
  t: func,
  inquiry: object,
  children: oneOfType([
    func, object, array
  ]),
  account: object,
  onCloseSearch: func
}



// WEBPACK FOOTER //
// ./src/components/inquiries/InquiryDetails.js